<template>
    <div class="location-container">
        <section class="container">
            <div class="row-custom-img reverse">
                <div class="col-custom">
                    <img src="../assets/images/de-praktijk-1.jpg" id="facings-techniques-img">
                </div>
                <div class="col-custom">
                    <h1 class="section-heading">Locatie</h1>
                    <p class="par-spacing">
                        Onze praktijk is gevestigd in het Gezondheidscentrum Achter de Linden aan de Schijndelseweg 13A, een centrale en goed bereikbare locatie. De rustige, groene omgeving draagt bij aan een ontspannen sfeer zodra u binnenstapt.
                    </p>
                    <p class="par-spacing">Met ruime parkeergelegenheid en goede bereikbaarheid, zowel met de auto als het openbaar vervoer, zorgen wij ervoor dat uw bezoek zo aangenaam mogelijk verloopt. Onze moderne praktijk biedt niet alleen hoogwaardige tandheelkundige zorg, maar ook een comfortabele en toegankelijke omgeving.</p>
                    <p class="par-spacing">Wij kijken ernaar uit u te verwelkomen bij Tandzorg Gestel, waar uw glimlach centraal staat!  </p>             
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
name: 'Location'
}
</script>

<style scoped>
.location-container {
    background-color: #f2f2f2;
    padding-top: 1.8rem;
}
.col-custom {
    flex-basis: 48%;
    /* padding: 30px 2px; */
}
.row-custom-img {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.col-custom img {
    width: 100%;
    max-width: 600px;
}
.col-custom h1 {
    padding-top: 0;
}

.section-heading {
    color: var(--blue);
    font-size: 3.2rem;
    margin-bottom: 0.8rem;
}
.col-custom p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}

#facings-techniques-img  {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
}

.par-spacing {
    margin-bottom: -5px;
}


@media(max-width: 978px) {
    .modern-techniques-container{
        padding: 5px 0 0;
    }
    .location-container {
        padding-top: 1.2rem;
    }
    .col-custom {
        flex-basis: 48%;
        padding: 10px 2px;
    }
    .row {
        flex-direction: column;
        margin-top: 10px;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }
    h3 {
        font-size: 16px;
    }
    .col-custom img {
        max-width: 100%;
    }
    .col-custom p {
        padding: 7px 0px 0px;
    }
    .reverse {
        flex-direction: column-reverse;
    }
    #facings-techniques-img {
        height: 300px;
        margin-top: 6px;
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(0,0,0,0.12);
    }

}
</style>